module.exports = __webpack_public_path__ + "static/media/top-screen@3x.77a842bb.png";